<template>
  <!-- 活动-转盘活动-排行榜 -->
  <div class="rotary-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <!-- <el-form-item>
          <el-input
            v-model.trim="query.user_id"
            placeholder="请输入用户id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="query.name"
            placeholder="用户名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">搜索</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
      <p>备注：列表按排名次数来：由大到小（第一名在最前面，最后一名在最后）</p>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="user_id" label="用户id" align="center">
        </el-table-column>
        <el-table-column label="用户名称" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.user.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户头像" align="center">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.user.avatar"
              style="width: 50px; height: 50px"
              :src="row.user.avatar"
              :lazy="true"
              fit="cover"
            ></el-image>
            <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="battle_use_num"
          label="热血次数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="open_use_num"
          label="普通次数"
          align="center"
        ></el-table-column>
        <el-table-column prop="use_num" label="总次数" align="center">
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        class="underBar"
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page || 15"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'

export default {
  name: 'vip_log',
  components: {
  },
  data() {
    return {
      dialogVisible: false,//弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        user_id: undefined,//用户id
        name: undefined,//用户id
      },
      dialogInfo: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('ranking', params).then(res => {
        if (res) {
          this.dataList = res
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,//当前页标
            per_page: res.per_page,//每页多少条
            total: res.total,//总数据条数
            total_pages: res.total_pages,//总页数
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openConfigDialog() {
      //打开配置活动弹窗
    },
    handleExport() {
      this.buttonLoading = true

      http
        .get(
          api + 'turntable_ranking_export',
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '转盘排行榜.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.vip_log-box {
  header {
  }

  .body-box {
  }
}
</style>